module.exports = __webpack_public_path__ + "img/account.662b4707.svg";